import React, { useState, useRef } from 'react';
import './card.css';
import { motion, useDomEvent } from "framer-motion";

const Card = (props) => {
  const imageUrl = props.data.image + "?alt=media";
  const id = imageUrl.match(/(?<=o\/)(.*?)(?=\?)/);


  const myTitle = props.data.title;
  //remove number and special charatere from title
  const title = myTitle.replace(/[0-9]/g, "");
  const [isOpen, setOpen] = useState(false);
  useDomEvent(useRef(window), "scroll", () => isOpen && setOpen(false));

  const transition = {
    type: "spring",
    damping: 25,
    stiffness: 120
  };

  const myNumber = props.data.title.match(/\d+/g);

 
  return (
    <div className={`image-container ${isOpen ? "open" : ""}`} >
      <motion.div
        animate={{ opacity: isOpen ? 1 : 0 }}
        transition={transition}
        className="shade transition-all duration-1000 flex flex-col gap-8  md:flex-row md:justify-center md:items-end"
        onClick={() => setOpen(false)}
      >
        <motion.h2 className="text-3xl text-primary mb-6">{title}</motion.h2>
        <motion.h3 className="text-3xl text-primary mb-6">numéro : <strong className='text-secondary'>{props.data.subtitle}</strong></motion.h3>
        {props.type === "atelier" ? ''
         :
        <motion.h3 className="text-3xl text-primary mb-6">dimensions : <strong className='text-secondary'>{props.data.dimensions}</strong></motion.h3>
        }
        
        <motion.p className="card-text text-primary">{props.data.description}</motion.p>
      </motion.div>
      <motion.div
        layoutId={id}
        onClick={() => setOpen(!isOpen)}
        layoutTransition={transition}
        className="card bg-transparent shadow-xl cursor-pointer z-5 relative">
        <motion.figure className='h-48 md:h-96'>
          <motion.img src={imageUrl} alt={props.data.title} />
        </motion.figure>
        {props.type === "atelier" ? '' :
        <motion.div className="z-50 card-title flex justify-between bottom-0 left-0 right-0 text-white bg-black pl-5 pr-5">
          <h1 className='font-thin text-sm'>{title}</h1>
          <p className='font-thin text-sm'>{myNumber ? myNumber : ''}</p>
        </motion.div>
        }
      </motion.div>
    </div>
  );
}

Card.propTypes = {};

Card.defaultProps = {};

export default Card;
